/* Allorn 2026 — header polish: a stronger glass once the page has scrolled.
   Hiding on scroll down / showing on scroll up is Dawn's own "on-scroll-up" sticky mode. */
(() => {
  const section = document.querySelector('.section-header');
  if (!section) return;
  let ticking = false;
  const update = () => {
    ticking = false;
    section.classList.toggle('is-scrolled', window.scrollY > 8);
  };
  window.addEventListener('scroll', () => {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }, { passive: true });
  update();
})();
